export default [
  {
    name: 'project_title',
    component_path: 'modules/templates/blocks/project/ProjectTitle'
  }
]